import { Bell, CheckCheck } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { NotificationItem } from './NotificationItem';
import { useNotifications } from '../hooks/useNotifications';
import { useAuth } from '@/hooks/useAuth';

export const NotificationCenter = () => {
  const { notifications, isLoading, markAsRead } = useNotifications();
  const { user } = useAuth();

  const handleMarkAllAsRead = () => {
    notifications?.forEach((notification) => {
      if (!notification.isRead) {
        markAsRead(notification.id);
      }
    });
  };

  const userNotifications = notifications?.filter(notification => notification.userId === user?.id);

  return (
    <div className="w-96 bg-card text-card-foreground rounded-xl shadow-lg border border-border">
      <div className="p-4 border-b border-border flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Bell className="w-6 h-6 text-primary" />
          <h2 className="text-lg font-semibold">Notifications</h2>
        </div>
        <Button variant="ghost" size="sm" onClick={handleMarkAllAsRead} className="text-sm">
          <CheckCheck className="w-4 h-4 mr-2" />
          Mark all as read
        </Button>
      </div>

      {isLoading ? (
        <div className="p-6 text-center">Loading...</div>
      ) : userNotifications && userNotifications.length > 0 ? (
        <div className="divide-y divide-border max-h-96 overflow-y-auto">
          {userNotifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onMarkAsRead={markAsRead}
            />
          ))}
        </div>
      ) : (
        <div className="p-6 text-center text-muted-foreground">
          You have no new notifications.
        </div>
      )}
    </div>
  );
};